import {ArenaHeaderButtonIconDefaultBox} from "./arena-header-button-icon.default.box";

export const ArenaHeaderButtonIconBox = ArenaHeaderButtonIconDefaultBox;